import { demoFlowFromParam, type DemoFlow } from "@/lib/demoFlows";

export const ARTICLE_JOB_SLUG = "senior-manager-global-sourcing";

export const ARTICLE_JOB_PATH = `/article/jobs/${ARTICLE_JOB_SLUG}`;
export const ARTICLE_APPLICATION_PATH = `${ARTICLE_JOB_PATH}/apply`;
export const ARTICLE_APPLICANT_PATH = "/article/applicant-flow";
export const ARTICLE_VOUCHER_PATH = "/article/voucher-flow";

// The job posting itself (title, pay, the source posting's URLs) lives in
// articleReview.ts, which only the demo pages import, so a production build
// and its source map carry none of it. Keep it there.

/**
 * Review fixture for the production Article integration.
 *
 * Real magic-link traffic continues to receive its workflow and organisation
 * name from the session API. This fixture only lets the review route exercise
 * those same components. Built by a pure function so a production build, which
 * never reads it, drops it (see `DEMO_SURFACES_IN_BUILD`).
 */
function buildArticleReviewFlow(): DemoFlow {
  const recruitingFlow = demoFlowFromParam("high_volume");
  if (!recruitingFlow) {
    throw new Error("The Article implementation requires the high-volume recruiting workflow.");
  }
  return { ...recruitingFlow, orgName: "Article" };
}

export const ARTICLE_REVIEW_FLOW: DemoFlow = /*#__PURE__*/ buildArticleReviewFlow();
